import React from 'react';
import classNames from 'classnames/bind';
import styles from './ShopActionColumn.css';

const cx = classNames.bind(styles);

class ShopActionColumn extends React.Component {
  render() {
    const { shop } = this.props;

    if (shop.status !== 'ACTIVE') {
      return (
        <button
          className={cx('btn', 'btn-action', 'btn-outline-primary')}
          onClick={this._handleContinueSetupOutlet}
        >
          Continue Setup
        </button>
      );
    }

    return (
      <div>
        <button
          className={cx('btn', 'btn-primary', 'btn-action')}
          onClick={this._handleStartSyncProduct}
        >
          Upload Products
        </button>
        <a
          className={styles['button-disconnect']}
          onClick={this._handleDisconnect}
        >
          Disconnect
        </a>
      </div>
    );
  }

  _handleDisconnect = () => {
    const { shop, outlet, onDisconnect } = this.props;
    onDisconnect(shop, outlet);
  };

  _handleStartSyncProduct = () => {
    const { shop, onProductSync } = this.props;
    onProductSync(shop);
  };

  _handleContinueSetupOutlet = () => {
    const { shop, outlet, onContinueSetupOutlet } = this.props;
    onContinueSetupOutlet(outlet.id, outlet.name, shop);
  };
}

export default ShopActionColumn;
